// frontend/src/components/profile-components/PurchasedProductsList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, ShoppingBag, ArrowLeft } from 'lucide-react';
import apiClient from '../../api/apiClient';
import VerticalContentCard from '../Category/VerticalContentCard';
import { useAuthContext } from '../../context/AuthContext';

export const PurchasedProductsList = () => {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorStatus, setErrorStatus] = useState(null);
  const { isLoggedIn } = useAuthContext();

  useEffect(() => {
    const fetchPurchased = async () => {
      if (!isLoggedIn) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await apiClient.get('/products/user/purchased/');
        const items = response.data.results || response.data;
        setProducts(items.slice(0, 10));
        setError(null);
      } catch (err) {
        console.error('خطا در دریافت محصولات خریداری شده:', err);
        setError('امکان بارگذاری محصولات خریداری شده وجود ندارد.');
        if (err.response) setErrorStatus(err.response.status);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPurchased();
  }, [isLoggedIn]);

  if (!isLoggedIn) return null;

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-10 rtl">
        <Loader2 className="w-6 h-6 animate-spin text-purple-700" />
        <span className="mr-3 text-gray-600 font-medium">در حال بارگذاری محصولات خریداری شده...</span>
      </div>
    );
  }

  if (error) {
    if (errorStatus === 401) {
      return (
        <div className="p-6 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
          <ShoppingBag className="w-10 h-10 mx-auto mb-3 text-gray-400" />
          <p className="font-semibold">محتوای  خریداری شده</p>
          <p className="text-[11px] mt-2">برای مشاهده خریدهای خود، ابتدا وارد شوید.</p>
        </div>
      );
    }
    return (
      <div className="p-4 bg-red-50 text-red-700 rounded-lg rtl text-center border border-red-100">
        خطا در دریافت اطلاعات. لطفاً اتصال خود را چک کنید.
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="p-10 bg-white rounded-lg shadow-sm text-center text-gray-500 rtl border border-gray-100">
        <ShoppingBag className="w-12 h-12 mx-auto mb-4 text-gray-300" />
        <p className="font-semibold text-gray-700">هنوز محصولی خریداری نکرده‌اید</p>
        <p className="text-[11px] mt-2">محصولات مورد نیاز خود را خریداری کنید تا در اینجا نمایش داده شوند.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4 rtl text-right">
      <div className="flex justify-between items-center">
        <h3 className="text-gray-800 font-bold text-[12px] md:text-xl">
          محتوای‌ خریداری شده
        </h3>
        <Link
          to="/profile/purchased"
          className="text-xs font-semibold text-gray-700 hover:text-purple-900 transition flex items-center"
        >
          <span>بیشتر</span>
          <ArrowLeft className="w-4 h-4 mr-1" />
        </Link>
      </div>

      <div className="flex overflow-x-auto space-x-4 space-x-reverse py-2 no-scrollbar">
        {products.map(product => (
          <div
            key={product.id}
            className="w-[280px] sm:w-[320px] flex-shrink-0"
          >
            <VerticalContentCard data={product} />
          </div>
        ))}
      </div>
    </div>
  );
};